import { render } from "./Dashboard.vue?vue&type=template&id=5ba23cbb&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=5ba23cbb&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=5ba23cbb&lang=css"
script.render = render
script.__scopeId = "data-v-5ba23cbb"

export default script